import {
	IonButton,
	IonContent,
	IonItem,
	IonLabel,
	IonList,
} from "@ionic/react";
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useParams, useHistory } from "react-router";
import { AppHeader } from "../../../components/Header/AppHeader";
import { getEntries } from "../../../services/users";
import { formatDate } from "../../../services/util";
import DateEatView from "./DateEatView";
import DateSleepView from "./DateSleepView";
import DateToiletView from "./DateToiletView";

export interface RouteParams {
	dateTS: string;
	id: string;
}

interface props {
	usersData: any;
	currentUser: any;
}

const DateView: React.FC<props> = ({ usersData, currentUser }) => {
	let { id, dateTS } = useParams<RouteParams>();

	const [user, setUser] = useState<any>({});

	useEffect(() => {
		if (currentUser.isAdmin) {
			if (usersData) {
				if (usersData[id]) {
					setUser({ ...usersData[id] });
				}
			}
		} else {
			setUser(currentUser);
		}
		//eslint-disable-next-line
	}, [usersData]);

	const getDate = () => {
		return formatDate(parseInt(dateTS));
	};

	return (
		<>
			<AppHeader title={getDate()} />
			<IonContent fullscreen className="ion-padding">
				<div className="content-wrapper">
					{user.study === "eat" && <DateEatView user={user} dateTS={dateTS} />}

					{user.study === "toilet" && (
						<DateToiletView user={user} dateTS={dateTS} />
					)}
					{user.study === "sleep" && (
						<DateSleepView user={user} dateTS={dateTS} />
					)}
				</div>
			</IonContent>
		</>
	);
};

const mapStateToProps = (state: any) => ({
	currentUser: state.user.userDetails,
	usersData: state.user.users,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DateView);
